module.exports = __webpack_public_path__ + "static/media/resinBookmarks.fc3a291e.jpg";